/**
 * Admin system config API endpoints.
 */

import { http } from './http';
import type { SystemConfig, SystemStats } from './types';

/** GET /api/v1/admin/system/config */
export async function getSystemConfig(): Promise<SystemConfig> {
  return http.get('/admin/system/config');
}

/** GET /api/v1/admin/system/stats */
export async function getSystemStats(): Promise<SystemStats> {
  return http.get('/admin/system/stats');
}

/** PATCH /api/v1/admin/system/config */
export async function updateSystemConfig(data: {
  maintenance_mode?: boolean;
  registration_enabled?: boolean;
  max_reports_per_user?: number;
}): Promise<{ config: SystemConfig }> {
  return http.patch('/admin/system/config', data);
}
